// Warunki `visible_when` / `required_when` pól schematu leada — lustro backendu
// (lead_shop/leadforms/conditions.py + services/visible_definitions.py). Czyste funkcje, bez DOM.
//
// Warunek = {key, in:[...]}; pole ma jeden warunek albo listę (wszystkie muszą zachodzić).
// Ukryty lub nieobecny kontroler liczy się jako fałsz (ukrycie przechodnie).

export function normaliseConditions(raw) {
  if (raw === null || raw === undefined) return []
  const items = Array.isArray(raw) ? raw : [raw]
  return items.filter((item) => item && typeof item === "object" && !Array.isArray(item))
}

// bool nie jest liczbą: true nie pasuje do 1 (jak _same w conditions.py).
function same(left, right) {
  return (typeof left === "boolean") === (typeof right === "boolean") && left === right
}

// Wartość kontrolująca (skalar albo lista dla multi_choice) trafia w listę dozwolonych.
export function valueIn(value, allowed) {
  const candidates = Array.isArray(value) ? value : [value]
  const options = Array.isArray(allowed) ? allowed : []
  return candidates.some((candidate) => options.some((option) => same(candidate, option)))
}

// Wszystkie warunki muszą zachodzić; brak wartości kontrolera albo kontroler ukryty = fałsz.
export function conditionsHold(conditions, values, visibleKeys) {
  for (const condition of conditions) {
    if (!Object.prototype.hasOwnProperty.call(values, condition.key)) return false
    if (!visibleKeys.has(condition.key) || !valueIn(values[condition.key], condition.in)) return false
  }
  return true
}

// Klucze widocznych definicji dla `values` (przechodnio: dziecko ukrytego rodzica jest ukryte).
// Niezależne od kolejności; (zabroniony) cykl daje „ukryte" zamiast pętli.
export function resolveVisibleKeys(definitions, values) {
  const byKey = new Map(definitions.map((definition) => [definition.key, definition]))
  const resolved = new Map()
  const inProgress = new Set()

  const isVisible = (key) => {
    if (resolved.has(key)) return resolved.get(key)
    if (inProgress.has(key)) return false
    inProgress.add(key)
    const conditions = normaliseConditions(byKey.get(key).visible_when)
    const visibleControllers = new Set(
      conditions.map((c) => c.key).filter((k) => byKey.has(k) && isVisible(k)),
    )
    const result = conditionsHold(conditions, values, visibleControllers)
    inProgress.delete(key)
    resolved.set(key, result)
    return result
  }

  return new Set([...byKey.keys()].filter((key) => isVisible(key)))
}

// Pole widoczne i wymagane: `required` zawsze, albo `required_when` spełnione (kontrolery muszą być widoczne).
export function isRequired(definition, values, visibleKeys) {
  if (!visibleKeys.has(definition.key)) return false
  if (definition.required) return true
  const conditions = normaliseConditions(definition.required_when)
  return conditions.length > 0 && conditionsHold(conditions, values, visibleKeys)
}
